export function commentableToString({
  created_at,
  author,
  content,
  ...val
}: ICommentable) {
  const date = new Date(created_at || "").toLocaleDateString('en-US').replace(/\//g, '-');
  const dateString = val.showObservationDatesOfFindings ? `${date} -` : '';
  if(val.is_completed_by_guest && val.completed_by){
    const name = val.completed_by
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
    return ` ${dateString} ${name} : ${content}`
  }
  return ` ${dateString} ${author.name} : ${content}`;
}

export interface ICommentable {
  id: number;
  created_at?: string;
  createdAt?: string;
  content: string;
  observation_type?: string;
  author: {
    name: string;
    id: number;
  };
  note: {
    content: string;
  };
  commentable_id?: number;
  userId?: number;
  is_completed_by_guest?: boolean;
  completed_by?: string;
  showObservationDatesOfFindings?: boolean;
}
